module.exports = __webpack_public_path__ + "static/media/FifteenMinuteRule.f0872e32.mp3";